module.exports = __webpack_public_path__ + "static/img/main_search_icon_g.cbecdb70.svg";